<template>
  <v-container class="a-title-section step">
    <v-row class="full-height">
      <v-col  cols="12" class="a-col-1" data-aos="zoom-in">
        <div class="about-title">
          <p id="a-title-1">About</p>
          <p id="a-title-2">our products</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
.a-title-section {
  margin-top: 200vh;
}
.a-col-1 {
  width: 100%; /* Chiều rộng của div */
  height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
  display: flex;
  justify-content: center;
  align-items: center;
}
.about-title {
  text-align: center;
}
#a-title-1{
  font-family: 'BodoniModa-Italic';
  font-size: 25px;
  font-weight: 700;
}
#a-title-2 {
  font-family: BodoniModa-Bold;
  font-size: 35px;
  text-transform: uppercase;
}
@media (max-width: 960px) {
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    margin-top: 20%;
  }
  .full-height {
    height: unset!important;
    width: 100%;
  }
}
</style>